import { adminGet, adminPost, adminPatch } from '../adminApi';

export const sGet = adminGet;
export const sPost = adminPost;
export const sPatch = adminPatch;
export const fmt = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const GREEN = '#0B6B55';

export const Page = ({ title, sub, action, children, testId }) => (
  <div className="p-8 max-w-7xl space-y-6" data-testid={testId}>
    <div className="flex items-start gap-4">
      <div className="mr-auto">
        <h1 className="text-4xl font-bold" style={{ color: '#1B1D1C' }}>{title}</h1>
        {sub && <p className="text-sm mt-1" style={{ color: '#6b7069' }}>{sub}</p>}
      </div>
      {action}
    </div>
    {children}
  </div>
);

export const Table = ({ cols, rows, render, empty = 'Nothing here yet', testId, widths }) => (
  <div className="rounded-lg border bg-white overflow-x-auto" style={{ borderColor: '#E5E3DC' }}>
    <table className={`w-full text-sm ${widths ? 'table-fixed' : ''}`} data-testid={testId}>
      {widths && <colgroup>{widths.map((w, i) => <col key={i} style={{ width: w }} />)}</colgroup>}
      <thead><tr className="text-left text-xs uppercase" style={{ background: '#F3F1EA', color: '#6b7069' }}>{cols.map(c => <th key={c} className="px-4 py-2">{c}</th>)}</tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={cols.length} className="px-4 py-8 text-center" style={{ color: '#9a9e96' }}>{empty}</td></tr>}
        {rows.map(render)}
      </tbody>
    </table>
  </div>
);

export const Pill = ({ children, tone = 'ok' }) => (
  <span className="text-xs px-2 py-0.5 rounded-full" style={tone === 'ok' ? { background: '#E7F2EE', color: GREEN } : tone === 'warn' ? { background: '#FFF7E6', color: '#8A6D1F' } : { background: '#F3F1EA', color: '#6b7069' }}>{children}</span>
);

export const Btn = ({ children, onClick, testId, variant = 'primary', disabled }) => (
  <button data-testid={testId} disabled={disabled} onClick={onClick}
    className={`h-8 px-3 rounded text-xs font-semibold ${variant === 'primary' ? 'text-white' : 'border'} disabled:opacity-50`}
    style={variant === 'primary' ? { background: GREEN } : { borderColor: '#D9D6CD', color: '#1B1D1C' }}>{children}</button>
);

export const Input = ({ label, value, onChange, testId, ...props }) => (
  <label className="block text-sm">
    <span className="block mb-1" style={{ color: '#4b504a' }}>{label}</span>
    <input data-testid={testId} value={value ?? ''} onChange={e => onChange(e.target.value)} className="w-full h-9 rounded border px-2 bg-white" style={{ borderColor: '#D9D6CD' }} {...props} />
  </label>
);

export const Select = ({ label, value, onChange, options, testId, multiple }) => (
  <label className="block text-sm">
    <span className="block mb-1" style={{ color: '#4b504a' }}>{label}</span>
    <select data-testid={testId} multiple={multiple} value={value} onChange={e => onChange(multiple ? Array.from(e.target.selectedOptions).map(o => o.value) : e.target.value)}
      className="w-full rounded border px-2 bg-white" style={{ borderColor: '#D9D6CD', minHeight: multiple ? 96 : 36 }}>
      {!multiple && <option value="">—</option>}
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </label>
);

export const scopeSummary = (s) => {
  if (!s) return 'all';
  const parts = [];
  if (s.tenant_ids?.length) parts.push(`${s.tenant_ids.length} tenant${s.tenant_ids.length > 1 ? 's' : ''}`);
  if (s.category_ids?.length) parts.push(`${s.category_ids.length} categor${s.category_ids.length > 1 ? 'ies' : 'y'}`);
  if (s.state_codes?.length) parts.push(s.state_codes.join(', '));
  if (s.location_ids?.length) parts.push(`${s.location_ids.length} location${s.location_ids.length > 1 ? 's' : ''}`);
  return parts.length ? parts.join(' · ') : 'all';
};
